import axios from './axios';

export default async function logout() {
  await axios.post('/logout');
  window.location.href = '/';
  window.sessionStorage.clear();
}
